import { createFileRoute } from '@tanstack/react-router'

import { JellyIcon } from '@/components/icons'
import { AppButton, BrandKitCard, SectionLabel } from '@/components/shared'
import { AppLink as Link } from '@/components/shell'
import { BRAND_KIT, MENU_FILES } from '@/mocks/klient/profilPodklady'

export const Route = createFileRoute('/klient/profil/podklady')({
  head: () => ({ meta: [{ title: 'Podklady · Aplikace Bitez' }] }),
  component: KlientPodklady,
})

function KlientPodklady() {
  return (
    <div className="px-4 pt-4 pb-6">
      <Link
        href="/klient/profil"
        className="-ml-1 flex w-fit items-center gap-1.5 rounded-full px-1 py-1 text-[10px] font-bold tracking-widest text-ink/40 uppercase transition-colors duration-150 hover:text-ink/70"
      >
        <JellyIcon name="arrow-left" className="size-3" />
        Profil
      </Link>

      <h1 className="font-display mt-3 text-2xl leading-[0.9] uppercase">Podklady</h1>
      <p className="mt-1.5 text-xs leading-relaxed text-ink/50">
        S čím Bára pracuje, když vám tvoří obsah.
      </p>

      <section className="animate-rise-up mt-6">
        <SectionLabel>Brand kit</SectionLabel>
        <div className="mt-3">
          <BrandKitCard kit={BRAND_KIT} />
        </div>
      </section>

      <section className="animate-rise-up mt-8" style={{ animationDelay: '60ms' }}>
        <SectionLabel>Menu a lístky</SectionLabel>
        <div className="mt-3 divide-y divide-ink/5 rounded-3xl bg-white px-5 shadow-sm">
          {MENU_FILES.map((file) => (
            <button
              key={file.name}
              type="button"
              className="flex w-full cursor-pointer items-center gap-3 py-4 text-left"
            >
              <JellyIcon name="file" className="size-4.5 shrink-0 text-ink/50" />
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-bold">{file.name}</span>
                <span className="block text-[10px] font-semibold text-ink/45">{file.updated}</span>
              </span>
              <JellyIcon name="arrow-right" className="size-3.5 shrink-0 text-ink/40" />
            </button>
          ))}
        </div>
        <AppButton variant="quiet" className="mt-3 w-full">
          <JellyIcon name="plus" className="size-3.5" />
          Nahrát nový lístek
        </AppButton>
        <p className="mt-2.5 text-[10px] leading-relaxed font-semibold text-ink/45">
          Z lístků bereme položky a ceny do příspěvků — čerstvý lístek znamená přesnější obsah.
        </p>
      </section>
    </div>
  )
}
